import React, { createContext, useContext, ReactNode } from 'react';
import { useCollaborationToast } from '../hooks/useCollaborationToast';

interface CollaborationContextType {
  showCollaborationAlert: (editorName: string, action?: string) => string;
  showCollaborationSuccess: (message: string) => string;
}

const CollaborationContext = createContext<CollaborationContextType | undefined>(undefined);

interface CollaborationProviderProps {
  children: ReactNode;
}

export const CollaborationProvider: React.FC<CollaborationProviderProps> = ({ children }) => {
  const { showCollaborationAlert, showCollaborationSuccess } = useCollaborationToast();

  return (
    <CollaborationContext.Provider value={{ 
      showCollaborationAlert, 
      showCollaborationSuccess 
    }}>
      {children}
    </CollaborationContext.Provider>
  );
};

export const useCollaboration = () => {
  const context = useContext(CollaborationContext);
  if (context === undefined) {
    throw new Error('useCollaboration must be used within a CollaborationProvider');
  }
  return context;
};